module.exports = __webpack_public_path__ + "static/media/shared-goals.37e2b950.svg";